module.exports = __webpack_public_path__ + "static/media/cms-drop-down-arrow.1cec5ca3.svg";